import { createContext, useContext, useState, useCallback } from 'react';

const LoginDrawerContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export function LoginDrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <LoginDrawerContext.Provider value={{ isOpen, open, close }}>
      {children}
    </LoginDrawerContext.Provider>
  );
}

export function useLoginDrawer() {
  return useContext(LoginDrawerContext);
}
